// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__r1QDr","container":"styles_container__2HPdx","title":"styles_title__3Vv0u","wrapper":"styles_wrapper__3zIuz","answer":"styles_answer__1OzAE"};